<script></script>

<div class="animationWrraper">
    <div class="typeText">
        <h1>TYPE & PLAY</h1>
    </div>
    <div class="overLayDiv" />
    <!-- <div class="overLayDivBackground">
        <img src="/images/Rectangle3.svg" alt="img" width="100%$" height="100%">
    </div> -->
    <div class="opustext">
        <h1>OPUS</h1>
        <p><b>“</b>revolutionizing <b>creativity”</b></p>
        <div class="svgWrraper">
            <svg
                viewBox="0 0 156 30"
                width="28.5vw"
                height="30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M147.05 4.99911L153.777 4.09222C154.29 4.02298 154.741 3.71558 154.994 3.26298C155.34 2.64116 155.247 1.86657 154.763 1.34453C154.405 0.958252 153.884 0.76702 153.361 0.830243L151.836 1.01452L144.74 2.03036L134.955 3.88611L117.647 8.10131L89.653 16.659L79.3453 19.472L68.2825 21.5359L57.9268 22.369L51.6249 22.2402L49.4488 21.9135C49.3917 21.9049 49.336 21.8888 49.2831 21.8655C49.036 21.7567 48.8816 21.5067 48.895 21.2371L48.9348 20.4379C48.9443 20.2468 48.984 20.0584 49.0523 19.8797L51.5089 13.4614C51.7606 12.8037 51.9412 12.1211 52.0475 11.425L52.3104 9.70351C52.4171 9.00434 52.3256 8.28924 52.0462 7.6395C51.7605 6.97514 51.2901 6.40669 50.6911 6.00161L50.4504 5.83887C50.1241 5.61828 49.7646 5.45153 49.3854 5.34503C48.9469 5.22184 48.4893 5.18122 48.036 5.22523L47.2218 5.30426C46.7063 5.35429 46.1969 5.45402 45.7006 5.60204L40.8377 7.05241L31.8368 10.3879L3.68327 22.2585C3.03923 22.5301 2.45593 22.9275 1.96759 23.4276L1.60134 23.8026C1.12707 24.2883 0.804728 24.9017 0.673819 25.5678L0.66768 25.599C0.529508 26.3021 0.617509 27.0308 0.919074 27.6807C1.21962 28.3284 1.71908 28.866 2.34233 29.2145C2.96473 29.5626 3.6834 29.7061 4.39159 29.6223C5.10212 29.5382 5.76763 29.2307 6.2923 28.7442L6.61119 28.4486C6.85877 28.219 7.07209 27.9551 7.24462 27.6649C7.47017 27.2855 7.76492 26.9519 8.11356 26.6813L10.4412 24.8747L15.6365 21.5798L21.6084 18.3451L27.2173 15.6588L34.1522 12.7722L39.3115 11.0424L42.8152 10.183C43.3606 10.0492 43.915 9.95548 44.4741 9.90251L45.8685 9.77039C45.935 9.76409 46.002 9.76644 46.0678 9.77737C46.4749 9.84495 46.7569 10.2206 46.7082 10.6303L46.5003 12.3812C46.4847 12.5128 46.4591 12.6431 46.4237 12.7708L44.1729 20.904C44.0904 21.2022 44.0356 21.5074 44.0091 21.8156L43.9946 21.9838C43.9406 22.6131 44.0265 23.2466 44.2461 23.8388L44.2623 23.8825C44.491 24.4987 44.8648 25.0508 45.3521 25.492C45.6533 25.7647 45.9936 25.991 46.3616 26.1634L46.6672 26.3066C47.4104 26.6549 48.214 26.8555 49.0336 26.8975L51.1057 27.0036C52.0842 27.0537 53.0653 27.0188 54.0378 26.8992L65.4396 25.4973L78.9296 22.7836L90.7475 19.621L108.332 14.2331L122.615 10.2139L138.665 6.51948L147.05 4.99911Z"
                    fill="#DA22FF"
                />
            </svg>
        </div>
    </div>
</div>

<style>
    .animationWrraper {
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: white;
    }
    .svgWrraper {
        overflow: hidden;
        width: 0vw;
        height: auto;
        margin-left: 56vw;
        margin-top: -2vw;
        /* visibility: hidden; */
        animation: sign 1s 3s forwards;
    }
    @keyframes sign {
        0% {
            width: 0vw;
        }
        100% {
            width: 27.1vw;
        }
    }
    /* .svgWrraper::after {
        position: absolute;
        content: "";
        height: 20%;
        width: 100%;
        top: 33vw;
        left: 54vw;
        background-color: #e2e2e2;
        animation: signMove 1.5s 3s forwards;
    }
    @keyframes signMove{
        0%{
            left: 54vw;
        }
        100%{
            left: 80vw;
        }
    } */
    .typeText {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .typeText h1 {
        font-family: "Roboto Mono";
        font-style: normal;
        font-weight: 700;
        font-size: 9.346vw;
        line-height: 16.822vw;
        letter-spacing: 1.869vw;
        color: black;
        width: 100vw;
        text-align: center;
    }
    .overLayDiv {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 85%;
        background-color: white;
        height: 5.5%;
        border-left: 1.402vw solid black;
        animation: type 0.5s 0.5s forwards, linebar 0.5s 1.5s forwards,
            linewidth 0.5s 1s forwards;
    }
    @keyframes type {
        0% {
            left: 50%;
        }
        10% {
            left: 59%;
        }
        13% {
            left: 59%;
        }
        20% {
            left: 66%;
        }
        23% {
            left: 66%;
        }
        30% {
            left: 74%;
        }
        33% {
            left: 74%;
        }
        40% {
            left: 82%;
        }
        43% {
            left: 82%;
        }
        50% {
            left: 100%;
        }
        53% {
            left: 100%;
        }
        60% {
            left: 111%;
        }
        63% {
            left: 111%;
        }
        70% {
            left: 119%;
        }
        73% {
            left: 119%;
        }
        80% {
            left: 126%;
        }
        83% {
            left: 126%;
        }
        100% {
            left: 135%;
        }
    }
    @keyframes linebar {
        0% {
            height: 5.5%;
        }
        100% {
            height: 100%;
        }
    }
    @keyframes linewidth {
        0% {
            width: 0vw;
            left: 85%;
            background-color: white;
        }
        50% {
            width: 100vw;
            background-color: black;
            left: 50%;
        }
        100% {
            width: 100vw;
            background: radial-gradient(
                65.43% 65.43% at 50% 29.89%,
                #3a0744 0%,
                #000000 100%
            );
            left: 50%;
        }
    }
    .opustext {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        text-align: center;
        transform: translate(-50%, -50%);
        font-family: "Orbitron";
        font-style: normal;
    }
    .opustext h1 {
        font-weight: 900;
        font-size: 9.346vw;
        line-height: 11.682vw;
        text-transform: uppercase;
        color: #ffffff;
        letter-spacing: 14vw;
        padding-left: 12vw;
        transform: scale(1);
        visibility: hidden;
        animation: opus 0.5s 1.4s forwards;
    }
    @keyframes opus {
        0% {
            visibility: hidden;
            transform: scale(1.3);
        }
        100% {
            visibility: visible;
            transform: scale(1);
        }
    }
    .opustext p {
        opacity: 0%;
        margin-top: 0vw;
        color: white;
        font-size: 20px;
        line-height: 25px;
        text-transform: lowercase;
        animation: para 1s 2s forwards;
    }
    @keyframes para {
        0% {
            opacity: 0%;
            margin-top: -10vw;
        }
        100% {
            opacity: 100%;
            margin-top: 0vw;
        }
    }
</style>
